import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'
import { CardGrid } from '@/common/components/cardGrid/CardGrid'
import type { CardGridCardTypes } from '@/common/model_builder/blockLists/cardGridCardTypes'

export const GridCardGrid: FC<GridElement<CardGridCardTypes>> = props => {
    if (!props.value) {
        return null
    }

    return <CardGrid cards={props.value} />
}
